/* Market Trend chart (snippets/pc-market-chart.liquid). Data: /apps/buylist/singles/chart?product=<id> → {printing, points:[[date, value]]}.
   Shows % change only, never prices (Trevor 2026-10-17). */
(function () {
  var RANGES = [["1M", 31, "Past Month"], ["3M", 92, "Past 3 Months"], ["6M", 183, "Past 6 Months"], ["1Y", 366, "Past Year"], ["All", 0, "All Time"]];
  var NS = "http://www.w3.org/2000/svg";
  var pctOf = function (a, b) { return a > 0 ? ((b - a) / a) * 100 : 0; };
  var pctText = function (p) { return (p > 0.05 ? "+" : p < -0.05 ? "−" : "") + Math.abs(p).toFixed(1) + "%"; };
  var month = function (s) { var d = new Date(s + "T12:00:00Z"); return d.toLocaleDateString("en-US", { month: "short", timeZone: "UTC" }) + " ’" + String(d.getUTCFullYear()).slice(2); };
  var day = function (s) { return new Date(s + "T12:00:00Z").toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }); };
  function el(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }
  function time(d) { return Date.parse(d + "T00:00:00Z"); }
  function isoMinus(d, days) { return new Date(time(d) - days * 86400000).toISOString().slice(0, 10); }

  function render(root, data) {
    var all = data.points, last = all[all.length - 1], spanDays = (time(last[0]) - time(all[0][0])) / 86400000;
    var ranges = RANGES.filter(function (r) { return r[1] === 0 || spanDays > r[1] * 0.6; });
    if (ranges.length > 1 && spanDays <= ranges[ranges.length - 2][1] * 1.1) ranges.pop();
    if (data.printing && data.printing !== "Normal" && data.printing !== "Foil")
      root.querySelector("[data-pcmv-sub]").textContent = "Near Mint " + data.printing + " · Based On Recent TCGplayer Sales";
    var tabs = root.querySelector("[data-pcmv-ranges]"), current = null;
    ranges.forEach(function (r) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "pcmv__range"; b.textContent = r[0]; b.setAttribute("role", "tab");
      b.addEventListener("click", function () { draw(r); });
      tabs.appendChild(b); r.btn = b;
    });
    function draw(r) {
      current = r;
      ranges.forEach(function (x) { x.btn.setAttribute("aria-selected", x === r ? "true" : "false"); });
      var from = r[1] ? isoMinus(last[0], r[1]) : "";
      var pts = all.filter(function (p) { return p[0] >= from; });
      if (pts.length < 2) pts = all.slice(-2);
      var p = pctOf(pts[0][1], last[1]), dir = Math.abs(p) < 0.5 ? "flat" : p > 0 ? "up" : "down";
      root.classList.remove("pcmv--up", "pcmv--down", "pcmv--flat"); root.classList.add("pcmv--" + dir);
      root.querySelector("[data-pcmv-change]").textContent = (dir === "up" ? "▲ " : dir === "down" ? "▼ " : "") + (dir === "flat" ? pctText(p) : Math.abs(p).toFixed(1) + "%");
      root.querySelector("[data-pcmv-span]").textContent = r[2];
      plot(root.querySelector("[data-pcmv-plot]"), pts);
    }
    root.hidden = false;
    var pick = ranges[Math.min(2, ranges.length - 1)];
    draw(pick);
    // Redraw at the real width (the block can be laid out after this script runs, or the window resized).
    var drawnW = root.querySelector("[data-pcmv-plot]").clientWidth;
    var redraw = function () { var w = root.querySelector("[data-pcmv-plot]").clientWidth; if (w && Math.abs(w - drawnW) > 4) { drawnW = w; draw(current); } };
    if (window.ResizeObserver) new ResizeObserver(redraw).observe(root); else window.addEventListener("resize", redraw);
  }

  function plot(box, pts) {
    box.innerHTML = "";
    var W = box.clientWidth, H = box.clientHeight || 240;
    if (!W) return;
    var padL = 6, padR = 14, padT = 14, padB = 26, base = pts[0][1];
    var svg = el("svg", { viewBox: "0 0 " + W + " " + H, role: "img", "aria-label": "Market trend chart" }, box);
    var vals = pts.map(function (p) { return p[1]; });
    var lo = Math.min.apply(null, vals), hi = Math.max.apply(null, vals);
    if (hi - lo < hi * 0.04) { var pad = Math.max(hi * 0.04, 0.05); lo -= pad; hi += pad; }
    var span = hi - lo; lo -= span * 0.1; hi += span * 0.1;
    var t0 = time(pts[0][0]), t1 = time(pts[pts.length - 1][0]);
    var x = function (d) { return padL + ((time(d) - t0) / Math.max(1, t1 - t0)) * (W - padL - padR); };
    var y = function (v) { return padT + (1 - (v - lo) / (hi - lo)) * (H - padT - padB); };
    for (var i = 0; i <= 4; i++) { var gy = padT + ((H - padT - padB) * i) / 4; el("line", { x1: padL, x2: W - padR, y1: gy, y2: gy, class: "pcmv__grid" }, svg); }
    el("line", { x1: padL, x2: W - padR, y1: y(base), y2: y(base), class: "pcmv__base" }, svg);
    var labels = W > 420 ? 4 : 3;
    for (var j = 0; j < labels; j++) {
      var p = pts[Math.round(((pts.length - 1) * j) / (labels - 1))];
      el("text", { x: x(p[0]), y: H - 6, "text-anchor": j === 0 ? "start" : j === labels - 1 ? "end" : "middle", class: "pcmv__axis" }, svg).textContent = month(p[0]);
    }
    var id = "pcmvg" + Math.random().toString(36).slice(2, 8);
    var g = el("linearGradient", { id: id, x1: 0, y1: 0, x2: 0, y2: 1 }, el("defs", {}, svg));
    el("stop", { offset: "0%", "stop-color": "currentColor", "stop-opacity": ".24", style: "color:var(--pcmv-c)" }, g);
    el("stop", { offset: "100%", "stop-color": "currentColor", "stop-opacity": "0", style: "color:var(--pcmv-c)" }, g);
    var line = pts.map(function (p, i) { return (i ? "L" : "M") + x(p[0]).toFixed(1) + " " + y(p[1]).toFixed(1); }).join(" ");
    el("path", { d: line + " L" + x(pts[pts.length - 1][0]).toFixed(1) + " " + (H - padB) + " L" + padL + " " + (H - padB) + " Z", fill: "url(#" + id + ")" }, svg);
    el("path", { d: line, class: "pcmv__line" }, svg);
    var end = pts[pts.length - 1];
    el("circle", { cx: x(end[0]), cy: y(end[1]), r: 9, class: "pcmv__ring" }, svg);
    el("circle", { cx: x(end[0]), cy: y(end[1]), r: 4.5, class: "pcmv__end" }, svg);
    var cross = el("line", { y1: padT, y2: H - padB, class: "pcmv__cross", visibility: "hidden" }, svg);
    var dot = el("circle", { r: 5, class: "pcmv__dot", visibility: "hidden" }, svg);
    var tip = document.createElement("div"); tip.className = "pcmv__tip"; tip.style.display = "none"; box.appendChild(tip);
    function show(ev) {
      var rect = svg.getBoundingClientRect(), px = ((ev.touches ? ev.touches[0].clientX : ev.clientX) - rect.left) * (W / rect.width);
      var best = pts[0], bd = Infinity;
      pts.forEach(function (p) { var d = Math.abs(x(p[0]) - px); if (d < bd) { bd = d; best = p; } });
      var cx = x(best[0]), cy = y(best[1]);
      cross.setAttribute("x1", cx); cross.setAttribute("x2", cx); cross.setAttribute("visibility", "visible");
      dot.setAttribute("cx", cx); dot.setAttribute("cy", cy); dot.setAttribute("visibility", "visible");
      tip.innerHTML = pctText(pctOf(base, best[1])) + "<span>" + day(best[0]) + "</span>";
      tip.style.display = "block";
      var left = (cx / W) * rect.width, half = tip.offsetWidth / 2;
      tip.style.left = Math.min(Math.max(left, half), rect.width - half) + "px";
      tip.style.top = Math.max(-8, (cy / H) * rect.height - tip.offsetHeight - 14) + "px";
    }
    function hide() { cross.setAttribute("visibility", "hidden"); dot.setAttribute("visibility", "hidden"); tip.style.display = "none"; }
    svg.addEventListener("mousemove", show); svg.addEventListener("mouseleave", hide);
    svg.addEventListener("touchstart", show, { passive: true }); svg.addEventListener("touchmove", show, { passive: true }); svg.addEventListener("touchend", hide);
  }

  function init(root) {
    if (root.dataset.pcmvReady) return; root.dataset.pcmvReady = "1";
    var src = root.dataset.pcmvSrc || "/apps/buylist/singles/chart?product=" + encodeURIComponent(root.dataset.pcmvProduct);
    fetch(src, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.status === 200 ? r.json() : null; })
      .then(function (data) { if (data && data.points && data.points.length >= 2) render(root, data); })
      .catch(function () {});
  }
  window.pcMarketChartInit = init;
  document.querySelectorAll("[data-pcmv-product]").forEach(init);
})();
